// file: VerifyEmail.js
import { Alert, Box, Button, CircularProgress, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import useAuth from "context/AuthContext"; // We'll add a new function to the context
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const { t } = useTranslation(["email_verification"]);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { resendVerificationEmail, loading } = useAuth(); // We'll create this function next

  // Get the email/phone from the URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const userIdentifier = queryParams.get('email_phone');

  const [message, setMessage] = useState({ text: '', severity: 'info' }); // 'info', 'error', 'success'

  const handleResendClick = async () => {
    setMessage({ text: t('sending'), severity: 'info' });
    try {
      await resendVerificationEmail(userIdentifier);
      setMessage({ text: t('verification_email_sent'), severity: 'success' });
    } catch (error) {
      setMessage({ text: error.message, severity: 'error' });
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 1, maxWidth: 400, mx: 'auto', mt: 8 }}>
      <Typography variant="h5" component="h1" gutterBottom align="center">
        {t('verify_your_email')}
      </Typography>
      <Typography variant="body1" sx={{
        marginBottom: "16px"
      }}>
        {t('verification_required_message')}
      </Typography>
      {userIdentifier && (
        <Typography
          variant="body2"
          sx={{
            fontStyle: 'italic',
            wordBreak: 'break-all',
            marginBottom: "16px"
          }}>
          {t('sending_to')}: <strong>{userIdentifier}</strong>
        </Typography>
      )}
      {message.text && (
        <Alert severity={message.severity} sx={{ mb: 2 }}>
          {message.text}
        </Alert>
      )}
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Button
          onClick={handleResendClick}
          variant="contained"
          color="primary"
          disabled={loading || !userIdentifier}
        >
          {t('resend_verification_email')}
        </Button>
        <Button
          onClick={() => navigate('/login')}
          variant="outlined"
        >
          {t('back_to_login')}
        </Button>
      </Box>
      {loading && <CircularProgress size={24} sx={{ display: 'block', mx: 'auto', mt: 2 }} />}
    </Paper>
  );
};

export default VerifyEmail;